var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mainContent" }, [
    _c("div", { staticClass: "mainContent__field" }, [
      _c(
        "label",
        { attrs: { for: "status_to_send" } },
        [
          _vm._v("\n      Status para enviar pedido (PLP)\n      "),
          _c(
            "sc-tooltip",
            {
              attrs: {
                type: "is-light",
                position: "is-left",
                label: "Status do TMS"
              }
            },
            [
              _c("sc-icon", {
                attrs: { size: "is-small", icon: "info-circle" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editable" },
        [
          _c("sc-multiple-selection", {
            attrs: {
              hasActions: false,
              options: _vm.status_to_send_options,
              disabled: _vm.disable_flags.status_to_send
            },
            on: {
              input: function($event) {
                _vm.updateField("psl_volume_states_to_send", $event)
              }
            },
            model: {
              value: _vm.value.psl_volume_states_to_send,
              callback: function($$v) {
                _vm.$set(_vm.value, "psl_volume_states_to_send", $$v)
              },
              expression: "value.psl_volume_states_to_send"
            }
          }),
          _vm._v(" "),
          _vm.disable_flags.status_to_send
            ? _c("sc-button", {
                attrs: { icon: "pen", theme: "default", size: "small" },
                on: {
                  click: function($event) {
                    _vm.showConfirmationDialog("status_to_send")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mainContent__field" }, [
      _c(
        "label",
        { attrs: { for: "status_after" } },
        [
          _vm._v("\n      Status após o envio\n      "),
          _c(
            "sc-tooltip",
            {
              attrs: {
                type: "is-light",
                position: "is-left",
                label: "Status do TMS"
              }
            },
            [
              _c("sc-icon", {
                attrs: { size: "is-small", icon: "info-circle" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editable" },
        [
          _c(
            "sc-select",
            {
              staticClass: "span__select",
              attrs: { disabled: _vm.disable_flags.status_after },
              on: {
                input: function($event) {
                  _vm.updateField("psl_volume_state_after_sent", $event)
                }
              },
              model: {
                value: _vm.value.psl_volume_state_after_sent,
                callback: function($$v) {
                  _vm.$set(_vm.value, "psl_volume_state_after_sent", $$v)
                },
                expression: "value.psl_volume_state_after_sent"
              }
            },
            _vm._l(_vm.status_after_options, function(status) {
              return _c(
                "option",
                { key: status.id, domProps: { value: status.value } },
                [_vm._v("\n          " + _vm._s(status.label) + "\n        ")]
              )
            })
          ),
          _vm._v(" "),
          _vm.disable_flags.status_after
            ? _c("sc-button", {
                attrs: { icon: "pen", theme: "default", size: "small" },
                on: {
                  click: function($event) {
                    _vm.showConfirmationDialog("status_after")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mainContent__field" }, [
      _c(
        "label",
        { attrs: { for: "psl_trigger_selected" } },
        [
          _vm._v("\n      Opção de envio\n      "),
          _c(
            "sc-tooltip",
            {
              attrs: {
                type: "is-light",
                position: "is-left",
                label: "Na criação do pedido"
              }
            },
            [
              _c("sc-icon", {
                attrs: { size: "is-small", icon: "info-circle" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editable" },
        [
          _c(
            "sc-select",
            {
              staticClass: "span__select",
              attrs: { disabled: _vm.disable_flags.psl_trigger_selected },
              on: {
                input: function($event) {
                  _vm.updateField("psl_trigger_selected", $event)
                }
              },
              model: {
                value: _vm.value.psl_trigger_selected,
                callback: function($$v) {
                  _vm.$set(_vm.value, "psl_trigger_selected", $$v)
                },
                expression: "value.psl_trigger_selected"
              }
            },
            _vm._l(_vm.psl_trigger_selected_options, function(status) {
              return _c(
                "option",
                { key: status.id, domProps: { value: status.value } },
                [_vm._v("\n          " + _vm._s(status.label) + "\n        ")]
              )
            })
          ),
          _vm._v(" "),
          _vm.disable_flags.psl_trigger_selected
            ? _c("sc-button", {
                attrs: { icon: "pen", theme: "default", size: "small" },
                on: {
                  click: function($event) {
                    _vm.showConfirmationDialog("psl_trigger_selected")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.value && _vm.value.psl_trigger_selected === "cut_times"
      ? _c(
          "div",
          { staticClass: "mainContent__field" },
          [
            _c(
              "label",
              { attrs: { for: "psl_trigger_cut_times" } },
              [
                _vm._v("\n      Horários de envio\n      "),
                _c(
                  "sc-tooltip",
                  {
                    attrs: {
                      type: "is-light",
                      position: "is-left",
                      label: "Janela de envio"
                    }
                  },
                  [
                    _c("sc-icon", {
                      attrs: { size: "is-small", icon: "info-circle" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("sc-multiple-selection", {
              attrs: {
                hasActions: false,
                options: _vm.psl_trigger_cut_times_options,
                disabled: _vm.disable_flags.psl_trigger_cut_times
              },
              on: {
                input: function($event) {
                  _vm.updateField("psl_trigger_cut_times", $event)
                }
              },
              model: {
                value: _vm.value.psl_trigger_cut_times,
                callback: function($$v) {
                  _vm.$set(_vm.value, "psl_trigger_cut_times", $$v)
                },
                expression: "value.psl_trigger_cut_times"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7d78f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7d78f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/sysnode/ScSysnodeCommons.vue
// module id = null
// module chunks = 